import { message, Mentions, Select, Switch, Popover} from "antd";
import React, { useEffect, useState } from "react";
import {
  BiEdit,
  BiFile,
  BiFileFind,
  BiSearchAlt,
  BiInfoCircle
} from "react-icons/bi";
import readXlsxFile, { readSheetNames } from "read-excel-file";
import { Button } from "../../components/Button";

import { api } from "../../services/api";
import { Page } from "./styles";
import fileExample from "../../assets/fileExample.png";
import planExample from "../../assets/planExample.png";
import planCircleExample from "../../assets/planCircleExample.png";
import { Pagination } from "../../components/Pagination";
import { Modal } from "../../components/Modal";
import { MessageSendCountModal } from "../../components/MessageSendCountModal";
import { IClient } from "../Clients";

interface UserInfo {
  id: string;
  usingExternalConnection: boolean;
}
interface IData {
  columns: string[];
  data: any[];
}
const MessageTrigger = () => {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const [clients, setClients] = useState<IClient[]>([]);
  const [clientSelected, setClientSelected] = useState<string>("");
  const [messageToSend, setMessageToSend] = useState("");
  const [previewMessage, setPreviewMessage] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const [loadClients, setLoadClients] = useState(false);
  const [search, setSearch] = useState("");
  const [random, setrandom] = useState(false);
  const [data, setData] = useState<IData | null>(null);
  const [dataFilter, setDataFilter] = useState<any[]>([]);
  const [file, setFile] = useState<File | null>(null);
  const [fileToSend, setFileToSend] = useState<File | null>(null);
  const [showMore, setShowMore] = useState(false);
  const [showReviewMessageModal, setShowReviewMessageModal] = useState(false);
  const [showMessageSendCountModal, setShowMessageSendCountModal] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limitPerPage, setLimitPerPage] = useState(10);

  function handleToggleSearch() {
    setSearchOpen(!searchOpen);
  }
  function toggleShowTutorial() {
    setShowMore(!showMore);
  }
  function handleNextPage() {
    if (page + 1 >= Math.ceil(totalCount / limitPerPage)) {
      return;
    }
    setPage((prevState) => prevState + 1);
  }
  function handlePreviusPage() {
    if (page - 1 < 0) {
      return;
    }
    setPage((prevState) => prevState - 1);
  }
  function handleLastPage() {
    setPage(Math.ceil(totalCount / limitPerPage) - 1);
  }
  function handleFirstPage() {
    setPage(0);
  }
  function handleChangeLimitPerPage(value: number) {
    if (totalCount > 0) {
      if (page + 1 > Math.ceil(totalCount / value)) {
        setPage(Math.ceil(totalCount / value) - 1);
      }
    }
    setLimitPerPage(value);
  }
  function handleSearch(value: string) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      setSearch(value);
      handleFirstPage();
    }, 500);
  }
  function handleChangeFile(files: FileList | null) {
    if (files?.length) {
      setFile(files[0]);
    }
  }
  async function handleFileInput() {
    if (!file) return;
    const columns: any[] = [];
    const values: any[] = [];
    const dataFile = await readXlsxFile(file);
    if (
      !dataFile[0].some(
        (v) =>
          "numero" === v
      )
    ) {
      setFile(null);
      return message.error('Campo "Número" não encontrado na planilha.');
    }
    dataFile[0].forEach((column) => {
      if (!columns.includes(column)) {
        columns.push(column);
      }
    });
    readSheetNames(file).then(async (data: string[]) => {
      for (const [index, sheetName] of data.entries()) {
        const fileData = await readXlsxFile(file, {
          sheet: sheetName,
        });
        if (fileData.length > 20000) {
          return message.error('O limite de dados é de 10 mil por xlsx.');
        }
        fileData.forEach((lines, i) => {
          if (index === 0 && i === 0) return;
          let obj: any = {};
          columns.forEach((column, i) => {
            obj[column] = lines[i];
          });
          values.push(obj);
        });
      }
      setTotalCount(values.length)
      setData({
        columns,
        data: [...values],
      });
    });
  }
  async function handleFileMessageInput(files: FileList | null) {
    if (files?.length) {
      const file = files[0];
      if (file && file.size > 20 * 1024 * 1024) {
        return message.warning('O arquivo selecionado é muito grande. Por favor, selecione um arquivo menor que 20MB.')
      }
      setFileToSend(file);
    }
  }
  function filterData() {
    if (data?.data) {
      const newData = [...data.data.slice(page * limitPerPage, page * limitPerPage + limitPerPage)];
      setDataFilter(newData);
    }
  }
  function handleShowReviewMessageModal() {
    let messageData = messageToSend;
    data?.columns.forEach((column) => {
      const index = messageData.indexOf(column);
      if (index !== -1) {
        messageData = messageData.replaceAll(`@${column}`, data.data[0][column])
      }
    })
    setPreviewMessage(messageData)
    setShowReviewMessageModal(true)
  }
  function handleCloseReviewMessageModal() {
    setShowReviewMessageModal(false);
    setPreviewMessage("");
  }
  function handleShowMessageSendCountModal() {
    handleCloseReviewMessageModal();
    setShowMessageSendCountModal(true);
  }
  function handleCloseMessageSendCountModal() {
    setShowMessageSendCountModal(false)
  }
  function fetchClients() {
    setLoadClients(true);
    api
      .get<[IClient[], number]>("clients")
      .then((response) => {
        const [data, total] = response.data;
        setClients(data);
        setTotalCount(total);
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => {
        setLoadClients(false);
      });
  }
  useEffect(() => {
    fetchClients();
  }, []);
  useEffect(() => {
    handleFileInput();
  }, [file]);

  useEffect(() => {
    filterData()
  }, [data]);
  useEffect(() => {
    filterData()
  }, [limitPerPage, page]);
  return (
    <>
      {
        showMessageSendCountModal &&
        <MessageSendCountModal
          data={data}
          file={fileToSend}
          clientId={clientSelected}
          messageToSend={messageToSend}
          onCancel={handleCloseMessageSendCountModal}
          random={random}
        />
      }
      {
        showReviewMessageModal &&
        <Modal
          cancel={handleCloseReviewMessageModal}
          confirm={handleShowMessageSendCountModal}
          title="Revise a mensagem antes de enviar"
          loading={false}
          btnTitle="Enviar"
        >
          <div style={{ width: '100%', height: '100%', textAlign: 'center' }}>
            {previewMessage && previewMessage}
          </div>
        </Modal>
      }
      <Page showMore={showMore}>
        <header>
          <span>Disparo de mensagem</span>
        </header>
        <div className="content">
          <div className="header-conf">
            <span>
              Como importar os dados? <BiFileFind />
            </span>
          </div>
          <div className="main-content tutor">
            <h3>
              <b>1 - Formato do arquivo</b>
            </h3>
            <p>
              O arquivo para importação precisa estar no formato <b>.xlsx</b>
            </p>
            <img src={fileExample} alt="file" />
            <h3>
              <b>2 - Conteúdo do arquivo</b>
            </h3>
            <p>
              A planilha deve ter um <b>cabeçalho</b> para que o programa
              identifique cada campo.
            </p>
            <p>
              Em caso de uma planilha com várias páginas, apenas a primeira
              precisa ter o cabeçalho.
            </p>
            <img src={planExample} alt="plan" />
            <p>
              Somento o campo <b>numero</b> é obrigatório para que o programa
              saíba para qual número enviará mensagem. O campo deve estar exatamente assim: <b>numero</b> todas as letras minúsculas e sem ascento.
            </p>
            <img src={planCircleExample} alt="plancircle" />
            <p>
              O número deve estar completo com <b>código do pais</b> e <b>DDD</b>.
            </p>
            <h3>
              <b>3 - Mensagem</b>
            </h3>
            <p>
              Na mensagem, é possível criar textos personalizados a partir dos
              campos apontados no cabeçalho da planilha.{" "}
            </p>
          </div>
          <Button
            title={showMore ? "Ver menos" : "Ver mais"}
            onClick={toggleShowTutorial}
            style={{ alignSelf: "center" }}
          />
        </div>
        <div className="content">
          <div className="header-conf">
            <span>
              Importação dos dados <BiFile />
            </span>
            {file ? file.name : "Nenhum arquivo importado"}
          </div>
          <div className="main-content">
            {!data ? (
              <label htmlFor="input-btn" className="btn-input">
                Importar Excel
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  id="input-btn"
                  value={""}
                  onChange={(e) => handleChangeFile(e.target.files)}
                />
              </label>
            ) : (
              <>
                <div className="header-main-content">
                  <label htmlFor="input-btn" className="btn-input">
                    Importar outro Excel
                    <input
                      type="file"
                      accept=".xlsx, .xls"
                      id="input-btn"
                      value={""}
                      onChange={(e) => handleChangeFile(e.target.files)}
                    />
                  </label>
                  <label className={`search ${searchOpen ? "active" : ""}`}>
                    <input
                      type="txt"
                      placeholder="Pesquisar cliente"
                      onChange={(ev) => {
                        handleSearch(ev.currentTarget.value);
                      }}
                    />
                    <BiSearchAlt onClick={handleToggleSearch} />
                  </label>
                </div>

                <table>
                  <thead>
                    <tr>
                      {data.columns.map((column) => (
                        <th rowSpan={1} colSpan={1}>
                          {column}
                        </th>
                      ))}
                    </tr>{" "}
                  </thead>
                  <tbody>
                    <>
                      {dataFilter.map((value, i) => {
                        return (
                          <tr>
                            {data.columns.map((column) => {
                              return (
                                <td rowSpan={1} colSpan={1}>
                                  {value[column]}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </>
                  </tbody>
                </table>
                <Pagination
                  totalItems={totalCount}
                  first={handleFirstPage}
                  last={handleLastPage}
                  limitChange={handleChangeLimitPerPage}
                  next={handleNextPage}
                  prev={handlePreviusPage}
                  currentPage={page}
                />
              </>
            )}
          </div>
        </div>
        <div className="content">
          <div className="header-conf">
            <span>
              Mensagem <BiEdit />
            </span>
          </div>
          <div className="main-content">
            <p style={{ alignSelf: "flex-start" }}>
              Selecione um cliente:
            </p>
            <Select
              style={{ alignSelf: "flex-start", width: 300 }}
              allowClear
              loading={loadClients}
              options={clients.map((client) => { return { value: client.id, label: client.name } })}
              onChange={(e) => setClientSelected(e)}
              value={clientSelected}
            />
            <div style={{ alignSelf: "flex-start", display: 'flex', alignItems: 'center', gap:'15px', margin: "20px 0" }}>
              <Switch size="small" style={{ margin: 0 }} checked={random} onChange={()=> setrandom((prev)=> !prev)} />
              <p
                style={{ margin: 0, display: 'flex', alignItems: 'center'}}
              >
                Enviar em intervalos aleatórios. <Popover content="Para cada mensagem é gerado um atraso no envio aleatório no intervalo de 0 a 5 minutos."><BiInfoCircle size={16} /></Popover>
              </p>
            </div>
            <p style={{ alignSelf: "flex-start" }}>
              Use o @ para encontrar as váriaveis disponíveis para o texto.
            </p>
            <Mentions
              rows={3}
              onChange={(e) => setMessageToSend(e)}
              value={messageToSend}
            >
              {
                data?.columns.map((column) => {
                  return (

                    <Mentions.Option value={column}>{column}</Mentions.Option>
                  )
                })
              }
            </Mentions>
            <div className="file-section">
              {
                fileToSend
                  ? <div className="file">
                    <BiFile size={25} />
                    <div>
                      <p>{fileToSend.name}</p>
                      <p>{(fileToSend.size / (1024 * 1024)).toFixed(2)} MB</p>
                    </div>
                    <span onClick={() => setFileToSend(null)}>Remover arquivo</span>
                  </div>
                  : (
                    <>
                      <label htmlFor="file-input" style={{ cursor: 'pointer' }}>
                        <p>Nenhum arquivo selecionado. <span>Importar arquivo</span></p>
                      </label>
                      <input id="file-input" type="file" style={{ display: 'none' }} onChange={(e) => handleFileMessageInput(e.target.files)} />
                    </>
                  )
              }
            </div>
            <Button
              title="Enviar mensagem"
              onClick={handleShowReviewMessageModal}
              style={{ alignSelf: "center" }}
              disabled={!data || !messageToSend.length || !clientSelected.length}
            />
          </div>
        </div>
      </Page>
    </>
  );
};
export { MessageTrigger };
